<template>
  <div>
    <div class="add__users">
      <div class="add__users--state">
        <div class="space__between align-items-center">
          <div class="label">{{ $lang.app.AGREEDS }}</div>
          <input id="employees-search-query-input" name="employeesSearchQuery" type="text" v-model="employeesSearchQuery"
                 :placeholder="$lang.app.SEARCH" autocomplete="off"
                 class="hidden p-0 text-sm border-t-0 border-r-0 border-l-0 border-b-1 border-gray-200 focus:border-indigo-600
                 focus:ring-0 mx-1"/>
          <a class="cursor-pointer" @click="selectAll(filteredEmployees)">{{ $lang.app.SELECT_ALL }}</a>
        </div>
        <div class="add__users__list custom-scrollbar h-48 overflow-y-auto">
          <div v-for="employee in filteredEmployees" :key="employee.id"
               class="adding__user__item" :class="{'opacity-50': employee.vacation}">
            <div class="input__group input__checkbox">
              <input type="checkbox" class="checkbox"
                     :checked="employees.some(e => e.id === employee.id)"
                     :disabled="employee.vacation"
                     @input="toggleEmployeeSelect(employee)">
            </div>
            <div class="cursor-pointer resolution__user__info"
                 @click="toggleEmployeeSelect(employee)">
              <div class="resolution__user__name">{{ employee.name }}</div>
              <div class="text-xs text-blue-800">{{ employee.position }}</div>
              <p v-if="employee.vacation" class="text-sm leading-none text-blue-900">
                <span v-if="employee.vacation.type === 'vacation'">
                  {{ $lang.app.ON_VACATION.replace(':start', $moment(employee.vacation.startDate).format('DD.MM.YYYY')).replace(':end', $moment(employee.vacation.endDate).format('DD.MM.YYYY')) }}
                </span>
                <span v-if="employee.vacation.type === 'trip'">
                  {{ $lang.app.ON_TRIP.replace(':start', $moment(employee.vacation.startDate).format('DD.MM.YYYY')).replace(':end', $moment(employee.vacation.endDate).format('DD.MM.YYYY')) }}
                </span>
                <span v-if="employee.vacation.type === 'disability'">
                  {{ $lang.app.ON_DISABILITY.replace(':start', $moment(employee.vacation.startDate).format('DD.MM.YYYY')).replace(':end', $moment(employee.vacation.endDate).format('DD.MM.YYYY')) }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="add__users--choisen">
        <div class="space__between">
          <div class="label">{{ $lang.app.SELECTED_EXECUTORS }}</div>
        </div>
        <div class="add__users__list custom-scrollbar h-48 overflow-y-auto">
          <div v-for="employee in employees" :key="employee.id" class="adding__user__item">
            <div class="input__group input__checkbox">
              <input type="checkbox" checked
                     class="checkbox"
                     @input="toggleEmployeeSelect(employee)">
            </div>
            <div class="resolution__user__info cursor-pointer" @click="toggleEmployeeSelect(employee)">
              <div class="resolution__user__name">{{ employee.name }}</div>
              <div class="text-xs text-blue-800">{{ employee.position }}</div>
              <div v-if="executorTypesGetValue('CLOSING_SIGNER') === employee.type"
                   class="resolution__user__rule">{{ $lang.app.CLOSING_SIGNER }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="input__group input__add__info">
      <label for="closing-signer-input" class="label">{{ $lang.app.ASSIGN_CLOSING_SIGNER }}</label>
      <div class="select__wrapper">
        <Multiselect
            id="closing-signer-input"
            v-model="closingSigner"
            @input="toggleAgreedClosingSigner"
            :options="employeeOptions"
            :placeholder="$lang.app.SELECT_FROM_OPTIONS"
            :searchable="true"
            :noOptionsText="$lang.app.LIST_EMPTY"
            :noResultsText="$lang.app.NOT_FOUND"
            :can-clear="false">
        </Multiselect>
      </div>
    </div>

    <div v-if="withAccountant" class="input__group input__add__info">
      <label for="accountant-input" class="label">{{ $lang.app.ASSIGN_ACCOUNTANT }}</label>
      <div class="select__wrapper">
        <Multiselect
            id="accountant-input"
            v-model="accountant"
            @input="toggleAgreedAccountant"
            :options="employeeOptions"
            :placeholder="$lang.app.SELECT_FROM_OPTIONS"
            :searchable="true"
            :noOptionsText="$lang.app.LIST_EMPTY"
            :noResultsText="$lang.app.NOT_FOUND"
            :can-clear="false">
        </Multiselect>
      </div>
    </div>
  </div>
</template>
<script>
import {getValueByKey as executorTypesGetValue} from "../../../../helpers/constants/executorTypes"

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    withAccountant: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      employees: [],
      employeesSearchQuery: '',
      closingSigner: null,
      accountant: null,
    }
  },
  computed: {
    filteredEmployees() {
      return this.options.filter(employee => employee.name.toLowerCase().includes(this.employeesSearchQuery.toLowerCase()))
    },
    employeeOptions() {
      return this.employees
          // .filter(item => item.type === this.executorTypesGetValue('SIGNER'))
          .map(e => ({
            value: e.id,
            label: e.name,
          }))
    },
  },
  created() {
    this.initEmployees(this.value)
  },
  watch: {
    value(val) {
      this.initEmployees(val)
    },
  },
  methods: {
    executorTypesGetValue,
    initEmployees(value) {
      this.employees = value.map(e => ({...e}))
      this.closingSigner = this.employees.find(item => item.type === this.executorTypesGetValue('CLOSING_SIGNER'))?.id
      this.accountant = this.employees.find(item => item.type === this.executorTypesGetValue('ACCOUNTANT'))?.id
    },
    selectAll(employees) {
      employees.forEach(employee => {
        if(!this.employees.some(e => e.id === employee.id)) {
          this.employees.push({...employee, type: this.executorTypesGetValue('SIGNER')})
        }
      })
      this.$emit('update', this.employees)
    },
    toggleEmployeeSelect(employee) {
      if(!employee.vacation) {
        if (this.employees.some(e => e.id === employee.id)) {
          this.employees = this.employees.filter(e => e.id !== employee.id)
          if(!this.employees.some(e => e.id === this.closingSigner)) {
            this.closingSigner = null
          }
          if(!this.employees.some(e => e.id === this.accountant)) {
            this.accountant = null
          }
        } else {
          this.employees.push({...employee, type: this.executorTypesGetValue('SIGNER')})
        }
        this.$emit('update', this.employees)
      }
    },
    toggleAgreedClosingSigner(employee) {
      this.employees = this.employees.map(employeeItem => {
        if(employeeItem.type === this.executorTypesGetValue('CLOSING_SIGNER')) {
          employeeItem.type = this.executorTypesGetValue('SIGNER')
        }
        if(employeeItem.id === employee) {
          employeeItem.type = this.executorTypesGetValue('CLOSING_SIGNER')
        }
        return employeeItem
      })
      this.$emit('update', this.employees)
    },
    toggleAgreedAccountant(employee) {
      this.employees = this.employees.map(employeeItem => {
        if(employeeItem.type === this.executorTypesGetValue('ACCOUNTANT')) {
          employeeItem.type = this.executorTypesGetValue('SIGNER')
        }
        if(employeeItem.id === employee) {
          employeeItem.type = this.executorTypesGetValue('ACCOUNTANT')
        }
        return employeeItem
      })
      this.$emit('update', this.employees)
    }
  }
}
</script>